// IndexPage

const Index = () => import('@/pages/index.vue')
const Login = () => import('@/pages/login.vue')
const WxTransition = () => import('@/pages/wxTransition.vue')
const Register = () => import('@/pages/register.vue')
const FindPwd = () => import('@/pages/findPwd.vue')
const JoinUs = () => import('@/pages/index/joinUs.vue')
const WriteResume = () => import('@/pages/index/writeResume.vue')
const Service = () => import('@/pages/service.vue')
const basicAdd = () => import('@/pages/basicAdd/index.vue')
const LongService = () => import('@/pages/longService.vue')
const Test = () => import('@/pages/test.vue')
const StepPc = () => import('@/pages/stepPc.vue')
const StepMini = () => import('@/pages/stepMini.vue')
const StepBPhone = () => import('@/pages/stepBPhone.vue')
const SiteList = () => import('@/pages/siteList.vue')
const Strategy = () => import('@/pages/strategy.vue')
const activity = () => import('@/pages/activity/index.vue')
const activityDetail = () => import('@/pages/activity/activityDetail.vue')
const aboutUs = () => import('@/pages/aboutUs.vue')

export default [
  {
    path: '*',//错误的url,显示主页
    name: '找不到该页面',
    component: Index,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/index',
    name: '首页',
    component: Index,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }

  },
  {
    path: '/login',
    name: '登录',
    component: Login,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/findPwd',
    name: '找回密码',
    component: FindPwd,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/wxTransition',
    name: '加载页',
    component: WxTransition,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/register',
    name: '注册',
    component: Register,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },

  {
    path: '/index/joinUs',
    name: '加入我们',
    component: JoinUs,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/index/writeResume',
    name: '填写简历',
    component: WriteResume,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  // 监理服务
  {
    path: '/service',
    name: '实地监理',
    component: Service,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  //基础增值--basicAdd
  {
    path: '/basicAdd',
    name: '基础增值',
    component: basicAdd,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/test',
    name: '测试页面',
    component: Test,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/stepPc',
    name: '操作流程',
    component: StepPc,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/stepMini',
    name: '操作流程',
    component: StepMini,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/stepBPhone',
    name: '绑定手机号流程',
    component: StepBPhone,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/siteList',
    name: '现场列表',
    component: SiteList,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/longService',
    name: '远程服务',
    component: LongService,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/strategy',
    name: '装修攻略',
    component: Strategy,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
      hideAds: true
    }
  },
  {
    path: '/activity',
    name: '最新活动',
    component: activity,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false
    }
  },
  {
    path: '/activityDetail',
    name: '最新活动详情',
    component: activityDetail,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false
    }
  },
  {
    path: '/aboutUs',
    name: '关于我们',
    component: aboutUs,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/indexRouter.js